import { Configuration, LogArgument } from 'rollbar'

export const rollbarConfig: Configuration = {
  enabled: true,
  environment: process.env.NODE_ENV,
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN || 'ceee3639629d4397824e9aee9edd17ff',
  captureUncaught: false,
  captureUnhandledRejections: true,
  ignoredMessages: [
    'Script error.',
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
    "Failed to execute 'insertBefore' on 'Node': The node before which the new node is to be inserted is not a child of this node.",
    "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
    'NotFoundError: The object can not be found here.',
    'Object Not Found Matching Id',
  ],
  checkIgnore: function (isUncaught: boolean, args: LogArgument[], item: any) {
    return item?.custom?.skip || isUncaught
  },
  payload: {
    code_version: process.env.NEXT_PUBLIC_CODE_VERSION,
    client: {
      javascript: {
        source_map_enabled: true,
      },
    },
  },
}
